export default {
  title: 'MyLink元宇宙员工 ID申请',
  c1: 'https://mylink.oss-accelerate.aliyuncs.com/myHomeIcon/applyIdBg_sc.png',
  c2: '活动规则',
  c3: '每位CMHK员工限领一个，按申请的先后顺序派发',
  c4: '申请后系统会立即派发，14天内可到元宇宙首页按“新获得”进入换号界面替换原有元宇宙ID，如在14天内没有替换号码则会自动失效',
  c5: '申请成功',
  c6: '没有可连接网络，请重试',
  c7: '员工ID不可重复领取',
  c8: '您不是员工，无法领取',
  C9: '元宇宙ID卡'
}
